#import "../fragments/email-automation-statuses-fragment.graphql"

mutation CancelPersonalEmailSequence($input: EmailAutomationStatusCancelInput!) {
    emailAutomationStatusCancel(input: $input) {
        emailAutomationStatus {
            ...EmailAutomationStatusesFragment
        }
    }
}
